import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './login.css';

const API_BASE = 'https://welaunchyou.com.br/crm-wly';

function Login({ setIsAuthenticated }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch(`${API_BASE}/login.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({ email, senha: password }),
        credentials: 'include', // mantém o cookie da sessão
      });

      // Parse seguro (evita quebrar se o servidor retornar HTML em erro)
      let data = null;
      const ct = response.headers.get('content-type') || '';
      if (ct.includes('application/json')) {
        data = await response.json();
      } else {
        data = { ok: false, error: 'Falha na autenticação.' };
      }

      if (response.ok && data) {
        // Flags e dados do usuário
        localStorage.setItem('isAuthenticated', 'true');
        localStorage.setItem('isAdmin', String(!!data.isAdmin));

        const usuarioObject = {
          id: data.id,
          nome: data.nome,
          tipo_usuario: data.tipo_usuario,
          whatsapp_ativo: Number(data.whatsapp_ativo ?? 0),
          ia_ativa: Number(data.ia_ativa ?? 0),
        };
        localStorage.setItem('usuario', JSON.stringify(usuarioObject));

        setIsAuthenticated(true);
        navigate('/dashboard', { replace: true });
      } else {
        setError(data?.error || 'Erro ao autenticar. Verifique suas credenciais.');
      }
    } catch (err) {
      setError('Erro ao se conectar ao servidor.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleSubmit}>
        <div className="login-header">
          <img
            src="https://welaunchyou.com.br/crm-wly/uploads/logos/logo-norea-n-branco2.png"
            alt="Logo Norea"
            className="login-logo"
          />
          <h2 style={{ borderBottom: "none" }}>Login</h2>
        </div>

        {error && <p className="error">{error}</p>}

        <input
          type="email"
          placeholder="E-mail"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          autoComplete="username"
        />
        <input
          type="password"
          placeholder="Senha"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          autoComplete="current-password"
        />

        <button type="submit" disabled={loading}>
          {loading ? 'Entrando...' : 'Entrar'}
        </button>

        <p className="forgot-password">
          <Link to="/recuperar-senha">Esqueci minha senha</Link>
        </p>
      </form>
    </div>
  );
}

export default Login;
